<template>
    <v-card class="pa-3 ma-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-card-account-details-outline</v-icon
            >
            <pre><v-toolbar-title><h2 style="margin-left:20px;"> Lista de fichajes</h2></v-toolbar-title></pre>
        </v-toolbar>
        <loader v-if="isloading"></loader>

        <v-row style="margin-bottom: 15px; margin-top: 15px">
            <v-col cols="12" md="3" v-if="admin">
                <v-autocomplete
                    hide-details
                    v-model="filtros.usuario"
                    :items="usuarios"
                    item-text="name"
                    item-value="id"
                    label="Usuarios"
                ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="3">
                <!-- <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="filtros.fecha_inicio"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="filtros.fecha_inicio"
                            label="Fecha de inicio"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                        >
                        </v-text-field>
                    </template>
                    <v-date-picker
                        color="#1d2735"
                        first-day-of-week="1"
                        v-model="filtros.fecha_inicio"
                        no-title
                        scrollable
                    >
                        <v-spacer></v-spacer>
                        <v-btn text color="red" @click="menu = false"
                            ><strong>Cancelar</strong></v-btn
                        >
                        <v-btn
                            text
                            color="success"
                            @click="$refs.menu.save(filtros.fecha_inicio)"
                            ><strong>OK</strong></v-btn
                        >
                    </v-date-picker>
                </v-menu> -->
                <date-select
                    v-model="filtros.fecha_inicio"
                    label="Fecha de inicio"
                ></date-select>
            </v-col>
            <v-col cols="12" md="3">
                <!-- <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="filtros.fecha_fin"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="filtros.fecha_fin"
                            label="Fecha de fin"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                        >
                        </v-text-field>
                    </template>
                    <v-date-picker
                        color="#1d2735"
                        first-day-of-week="1"
                        v-model="filtros.fecha_fin"
                        no-title
                        scrollable
                    >
                        <v-spacer></v-spacer>
                        <v-btn text color="red" @click="menu2 = false"
                            ><strong>Cancelar</strong></v-btn
                        >
                        <v-btn
                            text
                            color="success"
                            @click="$refs.menu2.save(filtros.fecha_fin)"
                            ><strong>OK</strong></v-btn
                        >
                    </v-date-picker>
                </v-menu> -->
                <date-select
                    v-model="filtros.fecha_fin"
                    label="Fecha de fin"
                ></date-select>
            </v-col>
            <v-col cols="12" sm="3">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="filtrar"
                            :loading="isloading"
                            :disabled="isloading"
                            color="primary"
                            class="mt-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text">mdi-filter</v-icon>
                        </v-btn>
                    </template>
                    <span>Filtrar</span>
                </v-tooltip>
            </v-col>
        </v-row>

        <v-data-table
            dense
            :headers="headers"
            :items="fichajes"
            :search="search"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
            <template v-slot:item.fecha="{ item }">
                {{ item.fecha | format_date }}
            </template>
            <template v-slot:item.vacaciones="{ item }">
                {{ item.vacaciones ? "Si" : "" }}
            </template>
            <template v-slot:item.hora__0="item">
                <div style="display: flex">
                    <v-text-field
                        v-mask="'##:##'"
                        v-model="item.item.hora_0"
                        @change="
                            editFicha(
                                item.item.id_0,
                                item.item.hora_0,
                                item.item.fecha
                            )
                        "
                    ></v-text-field>
                    <v-icon
                        @click="deleteFicha(item.item.id_0)"
                        small
                        class="mr-2"
                        color="red"
                    >
                        mdi-trash-can
                    </v-icon>
                </div>
            </template>
            <!-- <template v-slot:item.hora__0="item">
                <div style="display: flex">
                    <v-text-field
                        v-mask="'##:##'"
                        v-model="item.item.hora_0"
                        @change="
                            editFicha(
                                item.item.id_0,
                                item.item.hora_0,
                                item.item.fecha
                            )
                        "
                    ></v-text-field>
                    <v-icon
                        @click="deleteFicha(item.item.id_0)"
                        small
                        class="mr-2"
                        color="red"
                    >
                        mdi-trash-can
                    </v-icon>
                </div>
            </template> -->
            <template v-slot:item.hora__1="item">
                <div style="display: flex">
                    <v-text-field
                        v-mask="'##:##'"
                        v-model="item.item.hora_1"
                        @change="
                            editFicha(
                                item.item.id_1,
                                item.item.hora_1,
                                item.item.fecha
                            )
                        "
                    ></v-text-field>
                    <v-icon
                        @click="deleteFicha(item.item.id_1)"
                        small
                        class="mr-2"
                        color="red"
                    >
                        mdi-trash-can
                    </v-icon>
                </div>
            </template>
            <template v-slot:item.hora__2="item">
                <div style="display: flex">
                    <v-text-field
                        v-mask="'##:##'"
                        v-model="item.item.hora_2"
                        @change="
                            editFicha(
                                item.item.id_2,
                                item.item.hora_2,
                                item.item.fecha
                            )
                        "
                    ></v-text-field>
                    <v-icon
                        @click="deleteFicha(item.item.id_2)"
                        small
                        class="mr-2"
                        color="red"
                    >
                        mdi-trash-can
                    </v-icon>
                </div>
            </template>
            <template v-slot:item.hora__3="item">
                <div style="display: flex">
                    <v-text-field
                        v-mask="'##:##'"
                        v-model="item.item.hora_3"
                        @change="
                            editFicha(
                                item.item.id_3,
                                item.item.hora_3,
                                item.item.fecha
                            )
                        "
                    ></v-text-field>
                    <v-icon
                        @click="deleteFicha(item.item.id_3)"
                        small
                        class="mr-2"
                        color="red"
                    >
                        mdi-trash-can
                    </v-icon>
                </div>
            </template>
            <template v-slot:item.hora__4="item">
                <div style="display: flex">
                    <v-text-field
                        v-mask="'##:##'"
                        v-model="item.item.hora_4"
                        @change="
                            editFicha(
                                item.item.id_4,
                                item.item.hora_4,
                                item.item.fecha
                            )
                        "
                    ></v-text-field>
                    <v-icon
                        @click="deleteFicha(item.item.id_4)"
                        small
                        class="mr-2"
                        color="red"
                    >
                        mdi-trash-can
                    </v-icon>
                </div>
            </template>
            <template v-slot:item.hora__5="item">
                <div style="display: flex">
                    <v-text-field
                        v-mask="'##:##'"
                        v-model="item.item.hora_5"
                        @change="
                            editFicha(
                                item.item.id_5,
                                item.item.hora_5,
                                item.item.fecha
                            )
                        "
                    ></v-text-field>
                    <v-icon
                        @click="deleteFicha(item.item.id_5)"
                        small
                        class="mr-2"
                        color="red"
                    >
                        mdi-trash-can
                    </v-icon>
                </div>
            </template>
            <template v-slot:item.hora__6="item">
                <div style="display: flex">
                    <v-text-field
                        v-mask="'##:##'"
                        v-model="item.item.hora_6"
                        @change="
                            editFicha(
                                item.item.id_6,
                                item.item.hora_6,
                                item.item.fecha
                            )
                        "
                    ></v-text-field>
                    <v-icon
                        @click="deleteFicha(item.item.id_6)"
                        small
                        class="mr-2"
                        color="red"
                    >
                        mdi-trash-can
                    </v-icon>
                </div>
            </template>
            <template v-slot:item.hora__7="item">
                <div style="display: flex">
                    <v-text-field
                        v-mask="'##:##'"
                        v-model="item.item.hora_7"
                        @change="
                            editFicha(
                                item.item.id_7,
                                item.item.hora_7,
                                item.item.fecha
                            )
                        "
                    ></v-text-field>
                    <v-icon
                        @click="deleteFicha(item.item.id_7)"
                        small
                        class="mr-2"
                        color="red"
                    >
                        mdi-trash-can
                    </v-icon>
                </div>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    @click="editFichaje(item)"
                    small
                    class="mr-2"
                    color="blue"
                >
                    mdi-pencil
                </v-icon>

                <v-icon
                    @click="openDeleteDialog(item)"
                    small
                    class="mr-2"
                    color="red"
                >
                    mdi-trash-can
                </v-icon>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog_consumo">
            <v-card>
                <v-card-title>Consumos</v-card-title>
                <v-card-text>
                    <v-data-table
                        :items="consumo.consumos"
                        :headers="headers_consumos"
                    >
                        <template v-slot:item.nombre_archivo="{ item }">
                            <a target="_blank" :href="item.url">
                                <img
                                    :src="item.url"
                                    width="auto"
                                    height="60px"
                                />
                            </a>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog de eliminación -->
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            delete_dialog = false;
                            delete_id = null;
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteFichaje()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import dateSelect from "../../../components/general/dateSelect.vue";
export default {
    components: {
        dateSelect,
    },
    data() {
        return {
            tipo_gatos: [],
            delete_dialog: false,
            delete_id: null,
            headers_consumos: [
                { text: "Tipo", value: "tipo.nombre", sortable: false },
                { text: "Importe", value: "importe", sortable: false },
                { text: "Imagen", value: "nombre_archivo", sortable: false },
            ],
            horas_extra: 0,
            pago_extra: 0,
            horas_semana: 0,
            horas_trabajadas: 0,
            pago_extra: 0,
            menu: false,
            menu2: false,
            consumo: { total: 0, consumos: [] },
            usuarios: [],
            fichaje: {},
            filtros: {
                fecha_inicio: null,
                fecha_fin: null,
                usuario: null,
            },
            search: "",
            alto: 0,
            fichajes: [],
            rol: "",
            dialog: false,
            dialog_consumo: false,
        };
    },
    async created() {
        this.rol = localStorage.getItem("role");
        await this.getUsuarios();
        const date = new Date();
        const fecha_inicio = new Date(date.getFullYear(), date.getMonth(), 1);
        const fecha_fin = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.filtros.fecha_inicio = fecha_inicio.toISOString().slice(0, 10);
        this.filtros.fecha_fin = fecha_fin.toISOString().slice(0, 10);
        this.filtrar();
        this.getGastos();
    },
    methods: {
        // Acciones de fichaje
        // Lista los fichajes del litado
        filtrar() {
            if (this.rol != 1) {
                this.filtros.usuario = localStorage.getItem("user_id");
            }
            let filter_str = "?";
            if (this.filtros.usuario) {
                filter_str += `&usuario_id=${this.filtros.usuario}`;
            }
            axios
                .get(
                    `api/ordenes/fichajes/${this.filtros.fecha_inicio}/${this.filtros.fecha_fin}${filter_str}`
                )
                .then(
                    (res) => {
                        this.fichajes = res.data;
                    },
                    (err) => {
                        this.$toast.error("Error consultando los fichajes");
                    }
                );
        },

        // Edición de fichaje
        editFichaje(item) {
            this.fichaje = item;
            this.isNewFichajeVisible = true;
            // this.dialog = true;
        },

        // Eliminación de fichaje
        openDeleteDialog(item) {
            this.fichaje = item;
            this.delete_dialog = true;
        },
        deleteFichaje() {
            // axios.get(`api/delete-fichaje/${this.delete_id}`).then(
            axios.delete(`api/orden/fichaje/${this.fichaje.id}`).then(
                (res) => {
                    this.filtrar();
                    this.delete_dialog = false;
                    this.$toast.sucs(res.data.message);
                },
                (err) => {
                    this.$toast.error(err.response.data.message);
                }
            );
        },

        editFicha(id, hora, fecha) {
            const fecha_exp = fecha.split("-");
            const fec = `${fecha_exp[2]}-${fecha_exp[1]}-${fecha_exp[0]}`;

            axios
                .post(`api/save-fichaje`, {
                    id: id,
                    fecha: fec,
                    hora: hora,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Fichaje guardado con éxito");
                        this.fichaje = {};
                        this.$emit("done");
                    },
                    (err) => {
                        this.$toast.error("Error guardando el fichaje");
                    }
                );
        },
        deleteFicha(id) {
            this.delete_id = id;
            this.delete_dialog = true;
        },
        openConsumoModal() {
            this.dialog_consumo = true;
        },
        refresh() {
            this.dialog = false;
            // this.getFichajes();
            this.filtrar();
        },

        // Metodos generales
        async getUsuarios() {
            try {
                const res = await axios.get(`api/get-empleados-token-fichaje`);
                this.usuarios = res.data.data;
                this.usuarios.unshift("");
            } catch (error) {
                this.$toast.error("Error consultando los fichajes");
            }
        },
        getGastos() {
            axios.get(`api/get-tipos-gastos`).then(
                (res) => {
                    this.tipo_gatos = res.data;
                },
                (err) => {
                    this.$toast.error("Error consultando los fichajes");
                }
            );
        },

        // En desuso
        // Creación de PDF
        crearPDF() {
            if (this.rol != 1) {
                this.filtros.usuario = localStorage.getItem("user_id");
            }
            axios.post(`api/crear-pdf-fichajes`, this.filtros).then(
                (res) => {
                    const url = res.data.url_name;
                    window.open(`storage/fichajes/${url}`, "_blank");
                },
                (err) => {
                    this.$toast.error("Error consultando los fichajes");
                }
            );
        },
    },
    computed: {
        admin() {
            return this.rol == 1 || this.rol == 2 || this.rol == 9;
        },
        headers() {
            let res = [
                {
                    text: "Fecha",
                    value: "fecha",
                    sortable: false,
                },
                {
                    text: "Usuario",
                    value: "usuario",
                    sortable: false,
                },
                {
                    text: "Vacaciones",
                    value: "vacaciones",
                    sortable: false,
                },
                {
                    text: "Incidencia",
                    value: "tipo_incidencia",
                    sortable: false,
                },
                {
                    text: "Horas",
                    value: "horas",
                    sortable: false,
                },
                {
                    text: "Horas nocturnas",
                    value: "horas_extras",
                    sortable: false,
                },
            ];
            this.tipo_gatos.forEach((gasto) => {
                res.push({
                    text: gasto.nombre,
                    value: gasto.nombre,
                    sortable: false,
                });
            });

            return res;
        },
        isloading: function () {
            return this.$store.getters.getloading;
        },
    },
};
</script>
